"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreePreviewStatus = void 0;
var FreePreviewStatus;
(function (FreePreviewStatus) {
    FreePreviewStatus["Available"] = "available";
    FreePreviewStatus["InUse"] = "inUse";
    FreePreviewStatus["Expired"] = "expired";
})(FreePreviewStatus = exports.FreePreviewStatus || (exports.FreePreviewStatus = {}));
